export const CARD_MIN_WIDTH = 216;

export const CAROUSEL_CARD_GAP_WIDTH = 16;

export const MAX_NUM_CARDS = 4;

export const FOUR_CARDS_MIN_WIDTH = 912;

export const CAROUSEL_DISMISSAL_FLAG_ID = 'twco-carousel-dismissed-flag';
